import { render, staticRenderFns } from "./HeaderManageRetest.vue?vue&type=template&id=b5970282&scoped=true"
import script from "./HeaderManageRetest.vue?vue&type=script&lang=js"
export * from "./HeaderManageRetest.vue?vue&type=script&lang=js"
import style0 from "./HeaderManageRetest.vue?vue&type=style&index=0&id=b5970282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5970282",
  null
  
)

export default component.exports